import "../polyfills/abort";
import { Toaster } from "@newsela/angelou";
import Head from "next/head";
import Script from "next/script";
import PropTypes from "prop-types";

import AllPagesWrapper from "@/base/AllPagesWrapper/AllPagesWrapper";
import { TOASTER_Z_INDEX } from "@/base/base.constants";
import globalToasterRef from "@/base/globalToasterRef";
import InternalToolingPanel from "@/base/InternalToolingPanel/InternalToolingPanel";
import RootProviders from "@/base/RootProviders";

const PENDO_APP_ID = process.env["NEXT_PUBLIC_PENDO_APP_ID"] ?? "";
const PENDO_ENABLED = process.env["NEXT_PUBLIC_PENDO_ENABLED"] ?? "";

const propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.shape({
    [RootProviders.InitialPropsName]: PropTypes.shape(RootProviders.propTypes),
    dehydratedState: PropTypes.object,
  }),
};

const NewselaApp = ({ Component, pageProps }) => {
  return (
    <RootProviders
      {...pageProps[RootProviders.InitialPropsName]}
      dehydratedState={pageProps?.dehydratedState}
    >
      <Head>
        <title>Newsela | Instructional Content Platform</title>
        <meta
          name="description"
          content="Newsela is an Instructional Content Platform that supercharges reading engagement and learning in every subject."
        />
      </Head>

      {PENDO_ENABLED === "true" && PENDO_APP_ID && (
        <Script
          id="pendo-agent-loader"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `(function(apiKey){(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];v=['initialize','identify','updateOptions','pageLoad','track','trackAgent'];for(w=0,x=v.length;w<x;++w)(function(m){o[m]=o[m]||function(){o._q[m==='initialize'?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');})('${PENDO_APP_ID}');`,
          }}
        />
      )}

      <AllPagesWrapper>
        <Component {...pageProps} />
        {/* `Toaster` is at the bottom because it defines an `h2`
         * element and we need to have an `h1` first. In addition,
         * `Toaster` should provide a "live region" instead of a
         * "region" (the way it is implemented at this moment), which
         * makes its location unimportant for accessibility. If a toast
         * pops up, it should be announced by by the screen reader.
         *
         * TODO: change Toaster's role to `status` instead of `region`.
         *
         * Reference:
         * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/status_role
         */}
        <Toaster
          ref={globalToasterRef}
          __cssFor={{
            root: {
              zIndex: TOASTER_Z_INDEX,
            },
          }}
        />
      </AllPagesWrapper>
      <InternalToolingPanel />
    </RootProviders>
  );
};

NewselaApp.propTypes = propTypes;

export default NewselaApp;
